<mat-form-field appearance="fill" class="w-full">
  <mat-label *ngIf="enableMatLabel">{{ 'Search by hashtag' | transloco }}</mat-label>

  <mat-select
    [ngModel]="selectedHashtags"
    (ngModelChange)="onSelectionChange($event)"
    [multiple]="true"
    [disabled]="!hasOptions"
    [matTooltip]="selectionTooltip"
    matTooltipClass="my-tooltip"
    [attr.aria-label]="'Search by hashtag' | transloco"
    id="hashtag-filter-select"
  >
    <mat-option>
      <ngx-mat-select-search
        [formControl]="searchControl"
        [placeholderLabel]="'Search hashtags' | transloco"
        [noEntriesFoundLabel]="'No result found' | transloco"
        [showToggleAllCheckbox]="hasOptions"
        [toggleAllCheckboxChecked]="allSelected"
        [toggleAllCheckboxIndeterminate]="someSelected"
        [toggleAllCheckboxTooltipMessage]="'Select all' | transloco"
        (toggleAll)="onToggleAll($event)"
        [disableScrollToActiveOnOptionsChanged]="true"
      ></ngx-mat-select-search>
    </mat-option>

    <mat-option
      *ngFor="let hashtag of filteredHashtags; index as i"
      [value]="hashtag"
      [matTooltip]="hashtag"
      id="hashtag-filter-option{{ i }}"
    >
      {{ hashtag }}
    </mat-option>
  </mat-select>

  <button
    mat-icon-button
    matSuffix
    type="button"
    *ngIf="selectedHashtags.length > 0"
    (click)="clearSelection($event)"
    [matTooltip]="'Clear' | transloco"
    [attr.aria-label]="'Clear' | transloco"
    id="hashtag-filter-clear"
  >
    <mat-icon svgIcon="close" class="icon-size-4"></mat-icon>
  </button>
</mat-form-field>

<!-- Nothing to pick from: say so instead of showing an empty dropdown. -->
<div *ngIf="!hasOptions" class="hashtag-filter-empty" id="hashtag-filter-empty">
  {{ 'No hashtags yet' | transloco }}
</div>
